import React, { useState } from 'react';
import styled from 'styled-components';
import { breakpoint } from '@zocdoc-frontend-common/styles-grid';
import { InlineLink } from '@zocdoc-mezzanine/components-link';
import {
    labelExtraSmall,
    paragraphExtraSmall,
} from '@zocdoc-mezzanine/foundations-typography';
import { SERVICE_PHONE_NUMBER } from './constants';

export const MFAVerificationContact = () => {
    const [showServicePhoneNumber, setShowServicePhoneNumber] = useState(false);

    return (
        <FooterText>
            <MobileWrapper data-test="verification-form-footer-contact">
                <span>
                    Changed your number?{' '}
                    <StyledLink>
                        <InlineLink href={`tel:+1-${SERVICE_PHONE_NUMBER}`}>
                            Contact us
                        </InlineLink>
                    </StyledLink>
                </span>
            </MobileWrapper>
            <DesktopWrapper>
                <span>
                    Changed your number?{' '}
                    {!showServicePhoneNumber && (
                        <StyledLink>
                            <InlineLink
                                onClick={() => setShowServicePhoneNumber(true)}
                                data-test="mfa-verification-contact-us"
                            >
                                Contact us
                            </InlineLink>
                        </StyledLink>
                    )}
                    {showServicePhoneNumber && (
                        <span data-test="mfa-verification-service-phone">
                            Contact us at {SERVICE_PHONE_NUMBER}
                        </span>
                    )}
                </span>
            </DesktopWrapper>
        </FooterText>
    );
};

const FooterText = styled.div`
    ${paragraphExtraSmall};
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;

    ${breakpoint.small} {
        display: block;
    }
`;

const MobileWrapper = styled.span`
    display: block;

    ${breakpoint.small} {
        display: none;
    }
`;

const DesktopWrapper = styled.span`
    display: none;

    ${breakpoint.small} {
        display: block;
    }
`;

const StyledLink = styled.span`
    ${labelExtraSmall};
    text-decoration: underline;
    padding: 0px 2px;
`;
